import { PropsWithChildren, createContext, useContext, useMemo } from "react";
import { Outlet } from "react-router-dom";

import { useAuthContext } from "@covertree/auth";

interface BinderDocProviderState {
  isBinderAvailable: boolean;
}

const initialState: BinderDocProviderState = {
  isBinderAvailable: false,
};

const BinderDocContext = createContext<BinderDocProviderState>(initialState);

export const useBinderDocContext = () => useContext(BinderDocContext);

const BinderDocProvider = ({ children }: PropsWithChildren) => {
  const { tokenPayload } = useAuthContext();

  const isBinderAvailable = useMemo<boolean>(() => {
    if (!tokenPayload) return false;

    const isBinderAvailableFromToken = tokenPayload.isBinderAvailable;

    return isBinderAvailableFromToken
      ? isBinderAvailableFromToken === "true"
      : false;
  }, [tokenPayload]);

  return (
    <BinderDocContext.Provider value={{ isBinderAvailable }}>
      {!!children ? children : <Outlet />}
    </BinderDocContext.Provider>
  );
};

export default BinderDocProvider;
